import type { TimeEntriesFilterType } from 'ab-enums/timeEntries.enum';

import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/table${`?query=${string}${`&entries=${string}` | ''}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/table`;

export const URL = (tableRequestModel: TableQuery, entriesFilter: TimeEntriesFilterType): RouteDefinition =>
	`${baseRoute}/table?query=${encodeURIComponent((JSON.stringify(tableRequestModel)))}${entriesFilter ? `&entries=${entriesFilter}` : ''}`;
